<template>
  <div class="newdetail_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()">返回</div>
      <div class="big_tit">集团公告</div>
    </div>
    <div class="ctn">
      <img src="../images/new/33.jpg" width="100%" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Aboutus',
    data() {
      return {
        data: {},
      }
    },
    created() {
      this.$parent.footer('user', false)
    },
    mounted() {},
    methods: {},
  }
</script>
<style lang="less" scoped>
  .red_top_bg {
    // height: 168px;
    // background-image: url(../images/user/moneybag/bg.png);
    // position: fixed;
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: 100% 100%;

    background: linear-gradient(to left, #5674d3, #a8b6e5);
    height: 50px;
  }
</style>
